// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-features-FitImage-style__component--ehS4Y{display:inline-block;overflow:hidden;position:relative}.src-features-FitImage-style__component--ehS4Y img{position:absolute;top:50%;left:50%;min-width:100%;min-height:100%;transform:translateX(-50%) translateY(-50%)}`, "",{"version":3,"sources":["webpack://./src/features/FitImage/style.scss"],"names":[],"mappings":"AACA,+CACE,oBAAA,CACA,eAAA,CACA,iBAAA,CAEA,mDACE,iBAAA,CACA,OAAA,CACA,QAAA,CACA,cAAA,CACA,eAAA,CACA,2CAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.component {\n  display: inline-block;\n  overflow: hidden;\n  position: relative;\n\n  & img {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    transform: translateX(-50%) translateY(-50%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": `56px`,
	"lCompanyHeight": `114px`,
	"h2FontSize": `28px`,
	"h3FontSize": `20px`,
	"bodyLineHeight": `20px`,
	"lGnShrinkWindowWidth": `1591px`,
	"tableVerticalPadding": `8px`,
	"tableHorizontalPadding": `16px`,
	"lPersonnelBreakWidth": `1599px`,
	"cNavigationAccent": `#f57f17`,
	"cTableBodyOdd": `#fff`,
	"cTableBodyEven": `#f2f6f8`,
	"cTableHover": `#c5ddeb`,
	"cTableHeadOdd": `#eaf1f5`,
	"cTableHeadEven": `#dee8ef`,
	"zPageLoading": `2`,
	"component": `src-features-FitImage-style__component--ehS4Y`
};
export default ___CSS_LOADER_EXPORT___;
